import { take, takeLatest, call, put, select } from 'redux-saga/effects';

import { assemblyTree } from 'modules/quotes/quoteItemComponents/assemblyTree/data/actions';
import {
  collapseQuoteItem,
  removeQuoteItems,
} from 'modules/quotes/quoteItems/data/actions';
import {
  getExpandedQuoteItemId,
  getQuoteItemsById,
} from 'modules/quotes/quoteItems/data/selectors';

import quoteService from 'services/quoteService';

import { refreshQuote } from 'store/quotes/actions';
import { getQuoteId } from 'store/quotes/selectors';
import { QUOTE_REFRESH_ERROR, QUOTE_REFRESH_SUCCESS } from 'store/quotes/types';

import { types, mergeQuoteItems } from './actions';
import { getMergeType } from './reducer';

export default function* root() {
  yield takeLatest(types.MERGE_QUOTE_ITEMS_REQUEST, watchMergeQuoteItems);
}

function* watchMergeQuoteItems(action) {
  const { payload } = action;
  const { parentQuoteItemId, childrenQuoteItemIds, shouldRegenerateOps } =
    payload;

  // collapse quote item if one of the children is expanded
  const expandedQuoteItemId = yield select(getExpandedQuoteItemId);
  if (
    expandedQuoteItemId &&
    childrenQuoteItemIds.includes(parseInt(expandedQuoteItemId))
  ) {
    yield put(collapseQuoteItem.request());
  }

  try {
    const mergeType = yield select(getMergeType);
    const nextQuoteId = yield select(getQuoteId);
    if (mergeType === 'supportingFiles') {
      yield call(quoteService.quoteItems.mergeItemsAsSupportingFiles, {
        quoteId: nextQuoteId,
        parentQuoteItemId,
        childrenQuoteItemIds,
      });
    } else {
      yield call(quoteService.quoteItems.mergeItemsAsComponents, {
        quoteId: nextQuoteId,
        parentQuoteItemId,
        childrenQuoteItemIds,
        shouldRegenerateOps,
      });
    }

    yield put(refreshQuote.request());
    yield take([QUOTE_REFRESH_SUCCESS, QUOTE_REFRESH_ERROR]);

    const quoteItemsToRemove = yield select(
      getQuoteItemsById,
      childrenQuoteItemIds,
    );
    yield put(removeQuoteItems(quoteItemsToRemove));

    yield put(mergeQuoteItems.success());
  } catch (error) {
    yield put(mergeQuoteItems.error(error));
  }
  yield put(assemblyTree.markNeedsUpdate({}));
}
